import React from 'react';
import { motion } from 'framer-motion';

const Hosts = () => {
  return (
    <section className="py-16 px-6 max-w-5xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="bg-white rounded-3xl p-8 md:p-12 shadow-soft border border-dc-teal-deep/5 flex flex-col md:flex-row items-center gap-8 md:gap-12"
      >
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-2xl md:text-3xl font-bold text-dc-teal-deep mb-4">
            Live guidance from the room's hosts
          </h2>
          <p className="text-dc-text/80 leading-relaxed mb-8">
            Get direct access to Katrena Drake and Joe Moore. Both memberships include quarterly check-ins or guidance to hear what you are doing, where you are at, and what you are trying to clarify next.
          </p>
          <div className="flex justify-center md:justify-start gap-8">
            <div className="flex flex-col items-center">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/200fda6da1e90430528180c6a8bae324.png" 
                alt="Joe Moore" 
                className="w-24 h-24 rounded-full object-cover border-4 border-dc-gold-1/30 shadow-md" 
              />
              <span className="text-base font-semibold text-dc-teal-deep mt-3">Joe Moore</span>
            </div>
            <div className="flex flex-col items-center">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/0ed3d4d1559f6ef5b7a8dce606f087db.jpg" 
                alt="Katrena Drake" 
                className="w-24 h-24 rounded-full object-cover border-4 border-dc-gold-1/30 shadow-md" 
              />
              <span className="text-base font-semibold text-dc-teal-deep mt-3">Katrena Drake</span>
            </div>
          </div>
        </div>
        <div className="flex-1 flex justify-center md:justify-end w-full">
           <img 
            src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/59c50757f2cb20ec3738056fadf5e109.png" 
            alt="Signal & Structure AMA" 
            className="rounded-2xl shadow-float max-w-full h-auto md:max-h-96 object-contain border border-dc-teal-deep/10" 
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hosts;